export const CONNECT_TO_CARE_SOURCE = 'connect';

export const virtualAppointmentFromPair = <T extends { virtual: boolean | null }>(
  appointmentTypes: Array<T>
): T | null => {
  if (appointmentTypes.length !== 2) return null;

  const virtualAppointments = appointmentTypes.filter(appointmentType => appointmentType.virtual);
  if (virtualAppointments.length !== 1) return null;

  return virtualAppointments[0];
};
